<template>
  <VBlock
    class="preoder-cash-receipt"
    :direction="types.Direction.column"
    :sort="types.Sort.left_center"
  >
    <VBlock class="header-title" :sort="types.Sort.space_between" :padding="[0, 15]">
      <!-- <VCheckBox
        class="registration-cash-receipt"
        name="registration-cash-receipt"
        :checked="registration"
        :onChecked="onChangeRegistration"
      >-->
      <VSpan text="현금영수증" :size="16" />
      <!-- </VCheckBox> -->
      <VBlock class="cash-receipt-selector-wrapper">
        <VRadioBox
          class="cash-receipt-selector"
          name="cashreceipt"
          value="inactive"
          :state="!registration ? 'inactive' : ''"
          :onChecked="() => { onChangeRegistration(false) }"
        >
          <VSpan
            class="text"
            text="미신청"
            :size="14"
            :color="types.TextColor.darkGray"
            :spacing="-0.35"
          />
        </VRadioBox>
        <VRadioBox
          class="cash-receipt-selector"
          name="cashreceipt"
          value="active"
          :state="registration ? 'active' : ''"
          :onChecked="() => { onChangeRegistration(true) }"
        >
          <VSpan
            class="text"
            text="신청"
            :size="14"
            :color="types.TextColor.darkGray"
            :spacing="-0.35"
          />
        </VRadioBox>
      </VBlock>
    </VBlock>

    <VBlock v-if="registration" class="part-bottom" :direction="types.Direction.column">
      <VBlock
        class="contents"
        v-if="!cashReceiptFold"
        :direction="types.Direction.column"
        :padding="[20, 15]"
      >
        <!-- <VTabButton
          v-if="!cashReceiptFold"
          :state="type"
          :stateArr="typeArr"
          :onChangeInput="onChangeInput"
          :number="number"
          :onChangeState="onChangeState"
        />
        <VBlock v-else class="cash-receipt-save-number-wrapper" :sort="types.Sort.left_center">
          <VSpan class="cash-receipt-save-number" :text="cashReceiptNumber" :size="16" />
        </VBlock>-->
        <VRadioBox
          class="cash-receipt-item-selector"
          :class="[type !== 'PERSONAL' && 'margin']"
          name="cashreceipt-selector"
          value="PERSONAL"
          :state="type === 'PERSONAL' ? 'PERSONAL' : ''"
          :onChecked="() => onChangeState('PERSONAL')"
        >
          <VSpan
            class="text"
            text="개인 소득공제용"
            :size="16"
            :color="types.TextColor.darkGray"
            :spacing="-0.35"
          />
        </VRadioBox>
        <VBlock v-if="type === 'PERSONAL'" :margin="[10, 0, 15, 0]">
          <PersonalState :onChanged="onChangeInput" :number="number" />
        </VBlock>
        <VRadioBox
          class="cash-receipt-item-selector"
          name="cashreceipt-selector"
          value="BUSINESS"
          :state="type !== 'PERSONAL' ? 'BUSINESS' : ''"
          :onChecked="() => onChangeState('BUSINESS')"
        >
          <VSpan
            class="text"
            text="사업자 증빙용"
            :size="16"
            :color="types.TextColor.darkGray"
            :spacing="-0.35"
          />
        </VRadioBox>
        <VBlock v-if="type !== 'PERSONAL'" :margin="[10, 0, 0, 0]">
          <BusinessState :onChanged="onChangeInput" :number="number" />
        </VBlock>
      </VBlock>

      <VBlock
        v-if="!cashReceiptFold"
        class="save-cash-receipt"
        :sort="types.Sort.space_between"
        :padding="[0, 15]"
      >
        <VSpan text="다음에도 이 정보로 신청" :size="14" :color="types.TextColor.darkGray" :spacing="-0.35" />
        <VCheckBox
          class="save-cash-receipt-check"
          name="save-cash-receipt"
          :checked="save"
          :onChecked="onChangeSave"
        >
          <VSpan text="자동저장" :size="14" />
        </VCheckBox>
      </VBlock>
      <VBlock v-else class="save-cash-receipt" :sort="types.Sort.space_between" :padding="[0, 15]">
        <VSpan
          :text="`${phoneNumber} ${type === 'PERSONAL' ? '(개인 소득공제용)' : '(사업자 증빙용)'}`"
          :size="16"
          :color="types.TextColor.darkGray"
          :spacing="-0.38"
        />
        <button class="change-button" @click="() => { onChangeRegistration(true) }">
          <VSpan text="변경" :size="14" :color="types.TextColor.darkGray" />
        </button>
      </VBlock>
    </VBlock>
  </VBlock>
</template>

<script>
import VCheckBox from '../../atoms/VCheckBox'
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSpan, { TextColor, TextWeight } from '../../atoms/VSpan'
import VRadioBox from '../../atoms/VRadioBox'

import PersonalState from './states/PersonalState'
import BusinessState from './states/BusinessState'

export default {
  name: 'PreOrderCashReceipt',
  components: {
    VCheckBox,
    VBlock,
    VSpan,
    VRadioBox,
    PersonalState,
    BusinessState
  },
  props: {
    cashReceiptFold: {
      type: Boolean,
      default: false
    },
    isSigned: {
      type: Boolean,
      default: false
    },
    // 현금 영수증 신청 유무
    registration: {
      type: Boolean,
      default: false
    },

    save: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'PERSONAL' // OR BUSINESS
    },

    typeArr: {
      type: Array,
      default: () => [
        {
          name: 'PERSONAL',
          title: '개인 소득공제용'
          // component: PersonalState
        },
        {
          name: 'BUSINESS',
          title: '사업자 증빙용'
          // component: BusinessState
        }
      ]
    },

    number: {
      type: [String, Number],
      default: ''
    },

    onChangeRegistration: {
      type: Function,
      default: () => {}
    },

    onChangeSave: {
      type: Function,
      default: () => {}
    },

    onChangeInput: {
      type: Function,
      default: () => {}
    },

    onChangeState: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    phoneNumber() {
      return this.number.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3')
    },
    cashReceiptNumber() {
      const { title } = this.typeArr.find(obj => obj.type === this.type)

      if (this.number.length === 10) {
        return `${this.number.slice(0, 3)} ${this.number.slice(3, 6)} ${this.number.slice(
          6
        )} (${title})`
      }
      return `${this.number.slice(0, 3)} ${this.number.slice(3, 7)} ${this.number.slice(
        7
      )} (${title})`
    }
  },
  data() {
    return {
      types: {
        Direction,
        Sort,
        TextColor,
        TextWeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/_colors';

.preoder-cash-receipt {
  background-color: $white;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  /* padding: 15px 15px 15px 15px; */
  margin-bottom: 10px;
  border-bottom: 1px solid $light-gray-5;

  .header-title {
    width: 100%;
    height: 60px;
    align-items: center;

    // .header-inner {
    //   width: 100%;
    //   height: 24px;

    .cash-receipt-selector-wrapper {
      width: auto;
      height: 24px;

      .cash-receipt-selector {
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;

        .text {
          vertical-align: middle;
          line-height: 1;
        }

        &:first-child {
          margin-right: 15px;
        }
        // }
      }
    }
  }

  .part-bottom {
    /* margin-top: 18px; */

    border-top: 1px solid $light-gray-8;

    .save-cash-receipt {
      box-sizing: border-box;
      align-items: center;
      height: 60px;
      border-top: 1px solid $light-gray-8;

      .save-cash-receipt-check {
        padding-right: 0;
      }
    }

    .contents {
      .margin {
        margin-bottom: 15px;
      }

      .cash-receipt-item-selector {
        .text {
          vertical-align: middle;
          line-height: 1;
        }
      }
      /* margin-top: -12px;
      padding-left: 32px; */
    }
  }
}

.change-button {
  padding: 4px 10px;
  border-radius: 25px;
  background-color: #f6f6f6;
}
</style>
